import {Box, Typography} from '@mui/material'
import React from 'react'

import {FLEX_GAP} from '../constants'
import {TimeSlotSectionProps} from '../types'

import {TimeSlotComponent} from './TimeSlotComponent'

/**
 * Time slot section component that renders a group of time slots
 * Handles the grid layout and empty slots for proper alignment
 */
export const TimeSlotSection: React.FC<TimeSlotSectionProps> = ({
  title,
  slots,
  selectedTimeSlot,
  onTimeSlotSelect,
  onlyShowAvailableSlots
}) => {
  // Filter slots based on instant approval toggle
  const filteredSlots = React.useMemo(() => {
    if (!onlyShowAvailableSlots) return slots
    // When toggle is ON, show only slots with instant approval
    return slots.filter((slot) => slot.isAvailable)
  }, [slots, onlyShowAvailableSlots])

  if (filteredSlots.length === 0) return null

  return (
    <Box
      sx={{width: '100%', marginBottom: '24px'}}
      data-test-id={`time-slot-section-${title?.toLowerCase()}`}
    >
      {/* Section Header */}
      <Box sx={{marginBottom: '12px'}}>
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontWeight: 600,
            fontSize: '12px',
            lineHeight: '16px',
            color: '#54708C',
            textTransform: 'uppercase'
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* Time Slots Grid - Responsive Flex Layout */}
      <Box
        data-test-id="time-slot-grid"
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: `${FLEX_GAP}px`,
          width: '100%'
        }}
      >
        {filteredSlots.map((slot, slotIndex) => {
          const key = `${title}-${slotIndex}`
          const isSelected = selectedTimeSlot === slot.slot

          return (
            <TimeSlotComponent
              key={key}
              value={slot.slot}
              isAvailable={true}
              isSelected={isSelected}
              onSelect={onTimeSlotSelect}
              hasInstantApproval={slot.isAvailable}
            />
          )
        })}
      </Box>
    </Box>
  )
}
